import React from "react";
import { Text, Flex } from "@jsq/ds/core";
import { DetailedSepaPaymentPrefObjectType } from "../../../common/types";
import FormattedAddress from "../FormattedAddress";
import PaymentDetailsModalField from "../PaymentDetailsModalField";
import { SepaVisibleFields } from "../types";
import { getAddress } from "../utils";
import { isSepaFieldVisible } from "../utils/fieldVisibility";

export type SepaPaymentPrefDisplayProps = {
  sepaPaymentPrefFull: DetailedSepaPaymentPrefObjectType;
  visibleFields?: SepaVisibleFields;
};

export const SepaPaymentPrefDisplay: React.FC<SepaPaymentPrefDisplayProps> = ({
  sepaPaymentPrefFull,
  visibleFields,
}: SepaPaymentPrefDisplayProps) => {
  const accountHolderAddress =
    sepaPaymentPrefFull.accountHolderAddress &&
    getAddress(sepaPaymentPrefFull.accountHolderAddress);

  const gap = 8; // gap between rows and columns

  return (
    <Flex gap={gap} flexDirection="column" data-testid="SepaPaymentPrefDisplayFlex">
      <PaymentDetailsModalField
        label="Account holder name"
        value={sepaPaymentPrefFull.accountName}
        gap={gap}
        visible={isSepaFieldVisible("accountName", visibleFields)}
      />
      <PaymentDetailsModalField
        label="IBAN"
        value={sepaPaymentPrefFull.iban}
        gap={gap}
        visible={isSepaFieldVisible("iban", visibleFields)}
      />
      {sepaPaymentPrefFull.bank?.bicSwiftCode && (
        <PaymentDetailsModalField
          label="BIC / SWIFT code"
          value={sepaPaymentPrefFull.bank?.bicSwiftCode}
          gap={gap}
          visible={isSepaFieldVisible("bank", visibleFields)}
        />
      )}
      <PaymentDetailsModalField
        label="Bank name"
        value={sepaPaymentPrefFull.bank?.name}
        gap={gap}
        visible={isSepaFieldVisible("bank", visibleFields)}
      />
      {sepaPaymentPrefFull.additionalInstructions && (
        <PaymentDetailsModalField
          label="Additional instructions"
          value={sepaPaymentPrefFull.additionalInstructions}
          gap={gap}
          visible={isSepaFieldVisible("additionalInstructions", visibleFields)}
        />
      )}
      {isSepaFieldVisible("accountHolderAddress", visibleFields) && (
        <Flex gap={gap}>
          <Flex flexBasis="60%">
            <Text variant="secondary-md">Account holder address</Text>
          </Flex>
          <Flex flexBasis="100%" flexDirection="column">
            {accountHolderAddress && (
              <FormattedAddress address={accountHolderAddress} variant="regular-md" />
            )}
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
